import { render, staticRenderFns } from "./QuantityProblem.vue?vue&type=template&id=544d4e6b&"
import script from "./QuantityProblem.vue?vue&type=script&lang=js&"
export * from "./QuantityProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports